import { createAction } from 'vizzuality-redux-tools';

export const setReferences = createAction('REFERENCES/SET_REFERENCES');
